<template>
    <div class="wrapper">
        <div class="top">
            <div class="low__title" v-if="fields" data-animate="slideUp">{{ fields['Mini title section'] }}</div>
            <div class="title" v-if="fields" data-animate="slideUp">{{ fields['Title section'] }}</div>
            <div class="desc" v-if="fields" v-html="fields['Text section']" data-animate="slideUp"></div>
            <ButtonOrange style="width: 189px;" @click="this.$scrollTo('footer');" v-if="fields">{{ fields['Text Button'] }}</ButtonOrange>
            
        </div>
        <div class="bottom" v-if="fields" data-animate-group>
                <div class="stat" v-for="item in fields['Statistics Repeater']" data-animate="slideUp">
                    <div class="number">{{item.value}}</div>
                    <div class="descriprion">{{item.text}}</div>
                </div>
        </div>
    </div>
</template>

<script>
import ButtonOrange from '../UI/ButtonOrange.vue';
    export default {
        components: {
            ButtonOrange,
        },
        props: {
          fields: [Array,Object],
        },
    }
</script>

<style scoped>
.bottom{
    display: flex;
}
.bottom .stat{
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 220px;
}
.bottom .stat .number{
    /* Header/H1: 44px Medium */
        color: rgb(29, 29, 52);
        font-size: 44px;
        font-weight: 500;
        line-height: 140%;
        letter-spacing: 0%;
        text-align: left;
}
.bottom .stat .descriprion{
    /* Paragraph/P3: 16px Regular */
    color: rgb(85, 98, 114);
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
.wrapper{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    gap: 24px;
}
.low__title{
    /* Tabs/T1: 13px Medium */
color: rgb(85, 98, 114);
font-size: 13px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 16px;
}
.title{
/* Header/H1: 44px Medium */
color: rgb(5, 5, 5);
font-size: 44px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 24px;
}
.desc{
/* Paragraph/P1: 24px Regular */
color: rgb(85, 98, 114);
font-size: 24px;
font-weight: 400;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 32px;
}
@media (max-width: 1024px) {
    .title{
        font-size: 32px;
    }
    .desc{
        font-size: 20px;
    } 
    .bottom .stat .number{
        font-size: 32px;
    }
}
@media (max-width: 768px) {
    .title{
        font-size: 24px;
    }
    .desc{
        font-size: 16px;
    }
    .bottom{
        flex-direction: column;
        gap: 16px;
    }
    .bottom .stat{
        max-width: unset;
    }
    .bottom .stat .number{
        font-size: 24px;
    }
}
</style>